import { render, staticRenderFns } from "./SubmissionDetailTable.vue?vue&type=template&id=20837eea&scoped=true"
import script from "./SubmissionDetailTable.vue?vue&type=script&lang=js"
export * from "./SubmissionDetailTable.vue?vue&type=script&lang=js"
import style0 from "./SubmissionDetailTable.vue?vue&type=style&index=0&id=20837eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20837eea",
  null
  
)

export default component.exports